import { BASE_PATH } from 'config';
import { getIdFromObj } from 'utils/processors';

export const CREATION_TEMPLATE_FETCH_LIMIT = 1000;

const getPositiveIntegerId = (value) => {
    const id = Number(getIdFromObj(value));
    return Number.isInteger(id) && id > 0 ? id : null;
};

export const canCreateWorkOrderFromTask = (task) => getPositiveIntegerId(task) !== null;

const appendCreationQuery = (path, { template = null, sourceTask = null } = {}) => {
    const searchParams = new URLSearchParams();
    const templateId = getPositiveIntegerId(template);
    const sourceTaskId = getPositiveIntegerId(sourceTask);

    if (templateId) {
        searchParams.set('template', templateId);
    }
    if (sourceTaskId) {
        searchParams.set('sourceTask', sourceTaskId);
    }

    const query = searchParams.toString();
    return query ? `${path}?${query}` : path;
};

export const buildBusOppCreatePath = ({ businessOpportunityType, template = null }) =>
    appendCreationQuery(`/workmgmt/busopp/${businessOpportunityType?.acronym?.toLowerCase()}/create`, { template });

export const buildWorkOrderCreatePath = ({ workOrderType, template = null, businessOpportunity = null, sourceTask = null }) => {
    const basePath = businessOpportunity
        ? `/workmgmt/workorder/${workOrderType?.acronym?.toLowerCase()}/createfrom/${businessOpportunity?.businessOpportunityType?.acronym?.toLowerCase()}/${getIdFromObj(
              businessOpportunity
          )}`
        : `/workmgmt/workorder/${workOrderType?.acronym?.toLowerCase()}/create`;

    return appendCreationQuery(basePath, { template, sourceTask });
};

export const buildWorkOrderEditPath = (workOrder) => {
    const workOrderId = getPositiveIntegerId(workOrder);
    const workOrderType = workOrder?.workOrderType?.acronym?.toLowerCase();

    return workOrderId && workOrderType ? `/workmgmt/workorder/${workOrderType}/edit/${workOrderId}` : null;
};

export const buildSourceTaskEditPath = (task) => {
    const taskId = getPositiveIntegerId(task);
    const businessOpportunity = task?.businessOpportunity;
    const businessOpportunityId = getPositiveIntegerId(businessOpportunity);
    const businessOpportunityType = businessOpportunity?.businessOpportunityType?.acronym?.toLowerCase();

    if (taskId && businessOpportunityId && businessOpportunityType) {
        return `/workmgmt/busopp/${businessOpportunityType}/edit/${businessOpportunityId}`;
    }

    return taskId ? buildWorkOrderEditPath(task?.workOrder) : null;
};

export const openCreatePath = ({ path, navigate, state = {}, openInNewTab = false }) => {
    if (openInNewTab) {
        window.open(`${BASE_PATH}${path}`, '_blank', 'noopener,noreferrer');
        return;
    }

    navigate(path, { state });
};

export const getCreationQuery = (search = '') => {
    const searchParams = new URLSearchParams(search);
    const templateId = Number(searchParams.get('template'));
    const sourceTaskId = Number(searchParams.get('sourceTask'));

    return {
        templateId: Number.isInteger(templateId) && templateId > 0 ? templateId : null,
        sourceTaskId: Number.isInteger(sourceTaskId) && sourceTaskId > 0 ? sourceTaskId : null
    };
};

export const resolveCreationTemplate = (templates = [], templateId = null) => {
    const availableTemplates = Array.isArray(templates) ? templates.filter(Boolean) : [];

    if (templateId) {
        return availableTemplates.find((template) => getIdFromObj(template) === templateId) || null;
    }

    return availableTemplates.length === 1 ? availableTemplates[0] : null;
};
